// // src/utils/tenant.js
// const ROOT = "trekko.xyz";
// const RESERVED = new Set([
// 	"www",
// 	"api",
// 	"admin",
// 	"static",
// 	"dashboard",
// 	"westworld",
// ]);

// export function getSubdomain(host = window.location.host) {
// 	console.log("[tenant] host =", host);
// 	if (!host.endsWith(ROOT)) {
// 		console.log("[tenant] host does NOT end with ROOT", ROOT);
// 		return "";
// 	}
// 	const left = host.slice(0, -("." + ROOT).length);
// 	const sub = left || "";
// 	const ok = sub && !RESERVED.has(sub);
// 	console.log("[tenant] parsed subdomain =", sub, "usable?", ok);
// 	return ok ? sub : "";
// }

// src/utils/tenant.js
const ROOT = "trekko.xyz";
const RESERVED = new Set([
  "www",
  "api",
  "admin",
  "static",
  "dashboard",
  "westworld",
]);

export function getSubdomain(host = window.location.host) {
  // Allow local/dev mode
  if (
    process.env.VUE_APP_DEV === "True" || // from your .env
    host.includes("localhost") ||
    host.startsWith("127.0.0.1")
  ) {
    return ""; // Let Vuex load mock tenant instead of calling API
  }

  //  Normal production logic
  if (!host.endsWith(ROOT)) {
    return "";
  }

  const left = host.slice(0, -("." + ROOT).length);
  const sub = left || "";
  const ok = sub && !RESERVED.has(sub);

  return ok ? sub : "";
}
